define("powergen/helpers/helpers",
  [],
  function() {
    "use strict";
    Ember.Handlebars.helper('viewIndex', function(view) {
      return view.get('contentIndex') + 1;
    });

    Ember.Handlebars.helper("embolden", function(targetWord, subject) {
      var re;
      re = new RegExp(targetWord, "gi");
      return new Handlebars.SafeString(subject.replace(re, function(word) {
        return "<strong>" + word + "</strong>";
      }));
    });

  });